/**
 * Returns the project header display text.
 * Display project name and id if both are available, else only display the project ID.
 *
 * @param projectId - The ID of the project.
 * @param projectName - The name of the project.
 */
export function projectHeaderDisplay(
  projectId: number,
  projectName: string | null,
): { heading: string; subheading: string | null } {
  const validProjectName = projectName && projectName.trim() !== '';

  return validProjectName
    ? {
        heading: projectName.trim(),
        subheading: `Project ID #${projectId}`,
      }
    : {
        heading: `Project #${projectId}`,
        subheading: null,
      };
}
